import { render, staticRenderFns } from "./OtherAddAction.vue?vue&type=template&id=38c12ace&scoped=true"
import script from "./OtherAddAction.vue?vue&type=script&lang=js"
export * from "./OtherAddAction.vue?vue&type=script&lang=js"
import style0 from "./OtherAddAction.vue?vue&type=style&index=0&id=38c12ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c12ace",
  null
  
)

export default component.exports